import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const SearchResult = lazy(() => import("@/pages/SearchResult"));

export const Route = createFileRoute("/sokresultat")({
  head: () => seoHead("/sokresultat"),
  component: () => <SearchResult />,
});
